import api from './api';

export const getServicesApi = (params) => api().get('/services', { params });
export const addNewServiceApi = (data) => api().post('/services', data);
export const deleteServicesApi = (params) => api().delete(`/services/${params.id}`, { params });
export const updateServiceApi = (params) => api().put(`/services/${params.id}`, params.values);
